// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaService } from './services/pwa.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'soa-fe';

  // Inietta il servizio PWA per inizializzarlo immediatamente
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(private pwaService: PwaService) {}
}
